const VALID_DURATIONS = new Set(['single', 'multiday'])

function datePart(value) {
  if (value == null || value === '')
    return null
  const text = String(value).trim()
  const match = text.match(/^(\d{4}-\d{2}-\d{2})/)
  if (match)
    return match[1]
  const parsed = new Date(text)
  if (Number.isNaN(parsed.getTime()))
    return null
  return parsed.toISOString().slice(0, 10)
}

/** True when an actuals row represents a multiday trip/booking. */
export function isMultidayActualsRow(item, isTbn = false) {
  if (!item || item._overlap_group_header)
    return false
  if (isTbn)
    return parseInt(item.final_day_of_trip, 10) > 1
  const startDay = item.coach_manager_utc_day
  const finishDay = item.coach_manager_utc_finish_day
  if (startDay && finishDay)
    return String(startDay) !== String(finishDay)
  const startDate = datePart(item.start_datetime)
  const finishDate = datePart(item.finish_datetime)
  if (startDate && finishDate)
    return startDate !== finishDate
  return false
}

/** Trip duration state for an actuals row (single / multiday). */
export function actualsTripDurationState(item, isTbn = false) {
  if (!item || item._overlap_group_header)
    return null
  return isMultidayActualsRow(item, isTbn) ? 'multiday' : 'single'
}

export function matchesActualsTripDurationFilter(item, selectedDuration, isTbn = false) {
  if (!selectedDuration || !VALID_DURATIONS.has(selectedDuration))
    return true
  if (item && item._overlap_group_header)
    return false
  return actualsTripDurationState(item, isTbn) === selectedDuration
}

export function countActualsTripDuration(items, duration, isTbn = false) {
  return (items || []).filter(item => actualsTripDurationState(item, isTbn) === duration).length
}

/** Hover help for trip duration filter chips on the Actuals page. */
export const ACTUALS_TRIP_DURATION_FILTER_TOOLTIPS = {
  group: 'Filter the table by single-day vs multiday trips. Counts reflect the current date range and status filters (before the trip duration filter is applied).',
  single: 'Show trips that start and finish on the same calendar day. Click the chip to filter; click again to clear.',
  multiday: 'Show trips that span more than one calendar day. Click the chip to filter; click again to clear.',
}
